import axios from 'axios';

export default class Requests {
  constructor() {
    this.baseUrl = document.getElementById("hdnBaseUrl").value;
  }

  getStates() {
    var url = this.baseUrl +
      'api/State';

    return axios.get(url);
  }

}



// WEBPACK FOOTER //
// ./src/api/requests.js